import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './modules/shared/auth/login/login.component';
import { ForgotPasswordComponent } from './modules/shared/auth/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './modules/shared/auth/change-password/change-password.component';
import { ApiContractComponent } from './modules/shared/api-contract/api-contract.component';
import { SendFeedbackComponent } from './modules/shared/send-feedback/send-feedback.component';
import { AdvisorGuard } from './guards/advisor/advisor.guard';
import { AfaGuard } from './guards/afa/afa.guard';
import { AssistantGuard } from './guards/assiatant/assistant.guard';
import { PrivacyPoliciesComponent } from './modules/shared/privacy-policies/privacy-policies.component';
import { TermsUseComponent } from './modules/shared/terms-use/terms-use.component';
import { SupportUrlComponent } from './modules/shared/support-url/support-url.component';
import { DocumentationUrlComponent } from './modules/shared/documentation-url/documentation-url.component';
import { AdminGuard } from './guards/admin/admin.guard';
import { EcecutiveGuard } from './guards/executive/ececutive.guard';
import { SalesLeaderGuard } from './guards/sales-leader/sales-leader.guard';
import { LeadershipGuard } from './guards/leadership/leadership.guard';
import { RelationshipManagerGuard } from './guards/relationship-manager/relationship-manager.guard';
import { ExternalFileUploadComponent } from './modules/shared/external-file-upload/external-file-upload.component';
import { MarketingTeamGuard } from './guards/marketing-team/marketing-team.guard';
import { LendingOfficerGuard } from './guards/lending-officer/lending-officer.guard';
import { InsuranceAgentGuard } from './guards/insurance-agent/insurance-agent.guard';
import { ExternalMeetingSchedulerComponent } from './modules/shared/external-meeting-scheduler/external-meeting-scheduler.component';
const routes: Routes = [
	{
		path: 'admin',
		loadChildren: () => import('../app/modules/admin/admin.module').then((m) => m.AdminModule),
		// canActivate: [AuthGuard],
		canActivate: [AdminGuard]
	},
	{
		path: 'leadership',
		loadChildren: () => import('../app/modules/institutional-leader/institutional-leader.module').then((m) => m.InstitutionalLeaderModule,),
		// canActivate: [AuthGuard],
		canActivate: [LeadershipGuard],
	},
	{
		path: 'executive',
		loadChildren: () => import('../app/modules/executive/executive.module').then((m) => m.ExecutiveModule,),
		// canActivate: [AuthGuard],
		canActivate: [EcecutiveGuard]
	},
	{
		path: 'advisor-manager',
		loadChildren: () => import('../app/modules/advisor-manager/advisor-manager.module').then((m) => m.AdvisorManagerModule,),
		// canActivate: [AuthGuard],
		canActivate: [SalesLeaderGuard]
	},
	{
		path: 'advisor',
		loadChildren: () => import('../app/modules/advisor/advisor.module').then((m) => m.AdvisorModule,),
		// canActivate: [AuthGuard],
		canActivate: [AdvisorGuard]
	},
	{
		path: 'afa',
		loadChildren: () => import('../app/modules/advisor/advisor.module').then((m) => m.AdvisorModule,),
		// canActivate: [AuthGuard],
		canActivate: [AfaGuard]
	},
	{
		path: 'assistant',
		loadChildren: () => import('../app/modules/assistant/assistant.module').then((m) => m.AssistantModule,),
		// canActivate: [AuthGuard],
		canActivate: [AssistantGuard]
	},
	{
		path: 'relationship-manager',
		loadChildren: () => import('../app/modules/relationship-manager/relationship-manager.module').then((m) => m.RelationshipManagerModule,),
		// canActivate: [AuthGuard],
		canActivate: [RelationshipManagerGuard],
	},

	{
		// path: 'marketing-team',
		path: 'opportunity',
		loadChildren: () => import('../app/modules/marketing-team/marketing-team.module').then((m) => m.MarketingTeamModule,),
		// canActivate: [AuthGuard],
		canActivate: [MarketingTeamGuard],
	},
  {
		path: 'lending-officer',
		loadChildren: () => import('../app/modules/lending-officer/lending-officer.module').then((m) => m.LendingOfficerModule,),
		canActivate: [LendingOfficerGuard],
	},
  {
		path: 'insurance-agent',
		loadChildren: () => import('../app/modules/insurance-agent/insurance-agent.module').then((m) => m.InsuranceAgentModule,),
		canActivate: [InsuranceAgentGuard],
	},

  {
		path: "products",
		loadChildren: () => import('../app/modules/products/products.module').then((m) => m.ProductsModule),
	},

	{
		path: '',
		redirectTo: 'login',
		pathMatch: 'full',
	},
	{
		path: 'login',
		component: LoginComponent,
	},
	{
		path: 'forgot-password',
		component: ForgotPasswordComponent,
	},
	{
		path: 'verification',
		component: ChangePasswordComponent,
	},
	{
		path: 'api-contract',
		component: ApiContractComponent,
	},
	{
		path: 'feedback',
		component: SendFeedbackComponent,
	},
	{
		path: 'privacy-policy',
		component: PrivacyPoliciesComponent,
	},
	{
		path: 'terms-use',
		component: TermsUseComponent,
	},
	{
		path: 'support',
		component: SupportUrlComponent,
	},
	{
		path: 'documentation',
		component: DocumentationUrlComponent,
	},
	{
		path: 'file-upload',
		component: ExternalFileUploadComponent,
	},
  {
		path: 'schedule-meeting',
		component: ExternalMeetingSchedulerComponent,
	},
	{
		path: '**',
		component: LoginComponent,
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
